<template>
  <el-dialog
    append-to-body
    width="500px"
    title="确认到岗"
    center
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form
      v-loading="loading"
      element-loading-text="加载中…"
      ref="elFormDom"
      label-width="110px"
      label-position="right"
      :model="form.data"
      :rules="form.rules"
    >
      <el-form-item label="岗位名称：">
        {{ info.title }}
      </el-form-item>
      <el-form-item prop="date" label="到岗日期：">
        <el-date-picker
          v-model="form.data.date"
          type="date"
          value-format="yyyy-MM-dd"
          clearable
        >
        </el-date-picker>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-row type="flex" justify="center">
        <el-button
          type="primary"
          :loading="form.loading"
          :disabled="form.loading"
          @click="confirm"
          >确定</el-button
        >
        <el-button @click="toggle(false)">取消</el-button>
      </el-row>
    </template>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      info: {},
      visible: false,
      loading: false,
      form: {
        loading: false,
        data: {
          date: "",
        },
        rules: {
          date: [{ required: true, message: "必填项", trigger: "change" }],
        },
      },
    };
  },
  methods: {
    reset(done) {
      this.info = {};
      this.$refs.elFormDom.resetFields();
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
    getDetail(row) {
      this.info = row;
      this.form.data.date = row.part_arrival_date || "";
    },
    // 提交
    confirm() {
      this.$refs.elFormDom.validate((valid) => {
        if (valid) {
          this.form.loading = true;
          let params = {
            id: this.info.id,
            date: this.form.data.date,
            status:1
          };
          this.$http
            .post("/admin/order/arrival", params)
            .then((res) => {
              if (res.code === 1) {
                this.toggle(false);
                this.$emit("refresh");
              }
            })
            .finally(() => {
              this.form.loading = false;
            });
        }
      });
    },
  },
};
</script>
